export function NewsletterScoreboard({ scoreboard, labels }) {
  const board = scoreboard || {};
  const figures = [
    { key: "sessions", value: board.sessions || 0, label: labels.sessions },
    { key: "players", value: board.players || 0, label: labels.players },
    { key: "wins", value: board.wins || 0, label: labels.wins },
    {
      key: "rally",
      value: board.best_rally || 0,
      label: labels.rally,
      name: board.best_rally_name || "",
    },
  ];
  return (
    <ol className="pingflo-board">
      {figures.map((figure) => (
        <li key={figure.key} className="pingflo-figure">
          <strong>{figure.value}</strong>
          <span>{figure.label}</span>
          {figure.name ? <em>{figure.name}</em> : null}
        </li>
      ))}
    </ol>
  );
}
